/**
 * Enumeración de tipos de autenticación soportados
 */
export enum AuthType {
    STANDARD = 'STANDARD',
    GOOGLE = 'GOOGLE'
}

/**
 * Interfaz base para credenciales de autenticación
 */
export interface IAuthCredentials {
    username: string;
    authType: AuthType;
}

/**
 * Credenciales para autenticación estándar (usuario/contraseña)
 */
export interface IStandardAuthCredentials extends IAuthCredentials {
    password: string;
}

/**
 * Credenciales para autenticación con Google
 */
export interface IGoogleAuthCredentials extends IAuthCredentials {
    googleToken: string;
}

/**
 * Respuesta del servidor de autenticación
 */
export interface IAuthResponse {
    jwt: string;
    refreshToken?: string;
    user?: any;
    mfaRequired?: boolean;
    sessionId?: string;
}

/**
 * Payload del login request
 */
export interface ILoginPayload {
    username: string;
    password?: string;
    partner?: string | null;
    authType: AuthType;
    googleToken?: string;
}
